import { makeAutoObservable } from 'mobx'
import { fetchFilters } from '@services/api/filterAPI'
import RootStore from './RootStore'

class FilterStore {
  error
  filters
  loadingFilters = true
  constructor() {
    makeAutoObservable(this)
  }
  loadFilters = async () => {
    try {
      const sourceId = RootStore.wizardStore.sourceId
      this.filters = await fetchFilters(sourceId)
    } catch (e) {
      this.error = e
    } finally {
      this.loadingFilters = false
    }
  }
}

export default FilterStore
